import { CheckCircle2 } from "lucide-react";

function AcceptSuccessModal({ isOpen, guestName, onDone }) {
  if (!isOpen) return null;

  return (
    <>
      <div className="fixed inset-0 z-[80] bg-black/60" aria-hidden="true" />
      <div className="fixed inset-0 z-[90] flex items-center justify-center px-4 py-6">
        <div className="w-full max-w-sm rounded-2xl bg-white p-6 text-center shadow-2xl ring-1 ring-slate-200">
          <div className="mx-auto flex h-14 w-14 items-center justify-center rounded-full bg-[#e9f3f0]">
            <CheckCircle2 className="h-7 w-7 text-[#3a8c54]" />
          </div>
          <p className="mt-4 text-lg font-semibold text-[#570033]">
            Thanks for Accepting the Request
          </p>
          <p className="mt-2 text-sm text-slate-600">
            We will notify you when {guestName || "the guest"} credits your wallet.
          </p>
          <button
            type="button"
            onClick={onDone}
            className="mt-6 w-full rounded-2xl bg-[#570033] px-5 py-3 text-sm font-semibold text-white shadow-sm transition hover:bg-[#6f0044]"
          >
            Done
          </button>
        </div>
      </div>
    </>
  );
}

export default AcceptSuccessModal;
